import React, { useState } from "react";
import { FaFileDownload, FaPrint } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

import { canUseNativePrint } from "../../utils/rainMonthExport";

function RainSheetExportActions({
  onPrint,
  onExportPdf,
  exportingPdf = false,
  disabled = false,
}) {
  const { t } = useTranslation();
  const [showCursorHelp, setShowCursorHelp] = useState(false);
  const chromeUrl =
    typeof window !== "undefined" ? window.location.href : "http://localhost:3000";

  function handlePrintClick(event) {
    event.preventDefault();
    event.stopPropagation();
    if (!canUseNativePrint()) {
      setShowCursorHelp(true);
      return;
    }
    if (onPrint) onPrint(event);
  }

  function handleExportClick(event) {
    event.preventDefault();
    event.stopPropagation();
    setShowCursorHelp(false);
    if (onExportPdf) onExportPdf(event);
  }

  async function handleCopyChromeUrl() {
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(chromeUrl);
        toast.success(t("Endereço copiado. Cole no Chrome para imprimir em A4."));
      }
    } catch (error) {
      toast.info(chromeUrl);
    }
  }

  return (
    <div className="rain-sheet-export-actions">
      <button
        type="button"
        className="btn btn-default btn-sm"
        disabled={disabled || exportingPdf}
        onClick={handlePrintClick}
        title={t("Imprimir planilha")}
        aria-label={t("Imprimir planilha")}
      >
        <FaPrint aria-hidden="true" /> {t("Imprimir")}
      </button>
      <button
        type="button"
        className="btn btn-default btn-sm"
        disabled={disabled || exportingPdf}
        onClick={handleExportClick}
        title={t("Exportar PDF")}
        aria-label={t("Exportar PDF")}
      >
        <FaFileDownload aria-hidden="true" />{" "}
        {exportingPdf ? t("Gerando PDF...") : t("Exportar PDF")}
      </button>

      {showCursorHelp ? (
        <div className="farm-pluviometer-modal" role="dialog" aria-modal="true">
          <div
            className="farm-pluviometer-modal__backdrop"
            onClick={() => setShowCursorHelp(false)}
          />
          <div className="farm-pluviometer-modal__panel">
            <h3>{t("Imprimir em A4")}</h3>
            <p className="farm-pluviometer-modal__hint">
              {t(
                "Neste visualizador a impressão nativa fecha o Cursor. Abra a mesma página no Chrome, clique em Imprimir e confirme em A4 paisagem."
              )}
            </p>
            <code className="rain-print-host-url">{chromeUrl}</code>
            <div className="farm-pluviometer-modal__actions">
              <button
                type="button"
                className="btn btn-default btn-sm"
                onClick={handleCopyChromeUrl}
              >
                {t("Copiar endereço")}
              </button>
              <button
                type="button"
                className="btn btn-default btn-sm"
                onClick={handleExportClick}
                disabled={exportingPdf}
              >
                {t("Exportar PDF")}
              </button>
              <button
                type="button"
                className="btn btn-primary btn-sm"
                onClick={() => setShowCursorHelp(false)}
              >
                {t("Fechar")}
              </button>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
}

export default RainSheetExportActions;
